export const iconFontAwesomeSpinnersSnowflake = (
	<i className="fa-solid fa-snowflake"></i>
);
